define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/table/matrix/Path",
	"csi/xml"
], function(declare, _, PathMatrix, xml) {

	return declare(PathMatrix, {
		// path from view node to columns
		columnPath : "Child:Themes/Child:ThemeSeasons",

		/**
		 * @override
		 * filter nodes by row ColorSpecification and column Season
		 */
		_getSpecNodes : function(ctx, spec, nodes) {
			var urlSeason = spec.columnUrl;

		    // filter the ColorColorwayContext nodes by seasons from the theme
			return _.filter(nodes, function(node) {
				var theme = ctx.cache.getNode(node.__Parent__);
				return theme ? _.indexOf(theme.ThemeSeasons, urlSeason) !== -1 : false ;
			});
		}
	});
});